import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['service'])
export default class Service extends Component {

  constructor(props) {
    super(props)

    this.props.service.loadAllService()
  }

  newService(row) {
    this.props.service.newService(row)
  }

  updateService(row, cellText, cellValue) {
    this.props.service.updateService(row)
  }

  deleteService(id) {
    if (confirm('Are you sure you want to delete this Service?')) {
      this.props.service.deleteService(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteService(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newService.bind(this)
    }

    const serviceTable = (
      <BootstrapTable
          data={ this.props.service.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateService.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="description" dataSort={ true } editable={{ validator: Validators.validString }}>Description</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="baseCost" dataSort={ true } editable={{ validator: Validators.isNumber }}>Base Cost</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Service" content={ serviceTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/service.js